import type { Editor, JSONContent } from "@tiptap/core";

const applyPageContent = (editor: Editor, content: JSONContent): void => {
	// Clear history to avoid nodes with resources don't be error on undo/redo.
	// `emitUpdate: false`: this content came from a page read, so it is already on disk —
	// an emitted update would look like typing and save it back, over whatever the write
	// that prompted the read had put there. The template controller of an article made from
	// a template lets typing through only in its fields, and would drop the read altogether.
	editor
		.chain()
		.clearHistory()
		.setMeta("ignore-filter-controller", true)
		.setContent(content, { emitUpdate: false })
		.run();
};

export default applyPageContent;
